import { render, staticRenderFns } from "./ElFieldTextarea.vue?vue&type=template&id=f2156030"
import script from "./ElFieldTextarea.vue?vue&type=script&lang=js"
export * from "./ElFieldTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports